import { useGetPriceList } from "shared-apis/api";
import { usePriceListState } from "atoms/priceListAtom";
import { PriceListItem } from "types";

import { Row } from "components/Row/Row";
import { Paragraph } from "components/Paragraph/Paragraph";

import styles from "./styles.module.scss";

export const PricelistBody = (): JSX.Element => {
  const { priceListState, setPriceListState } = usePriceListState();

  const { data: priceList = [] } = useGetPriceList();

  const handleClick = (item: PriceListItem) => {
    setPriceListState({ activeItem: item });
  };

  return (
    <div className={styles.container}>
      {priceList?.map((item: PriceListItem) => (
        <Row
          key={item.pricelistid}
          onClick={() => handleClick(item)}
          isActive={priceListState.activeItem?.pricelistid === item.pricelistid}
        >
          <Paragraph>{item.name}</Paragraph>
        </Row>
      ))}
    </div>
  );
};
